import { Injectable, isDevMode } from '@angular/core';
import { RolesDaoService } from 'src/app/dao/roles-dao-service/roles-dao.service';
import { EMPTY, Subject } from 'rxjs';
import { Rol } from 'src/app/models/roles-models/rol.model';
import { Center } from 'src/app/models/center-model/center.model';
import { MenuSection } from 'src/app/models/menu-section-model/menu-section.model';
import { UserService } from 'src/app/services/user-service/user.service';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { UserStorageService } from '../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  accessToken = 'ROL';
  refreshRolesListener = new Subject<any>();
  refreshRoleListener = new Subject<any>();
  searchRolesListener = new Subject<any>();

  constructor(private rolesDaoService: RolesDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getRolesList() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.getRolesList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const roles = new Array<Rol>();
          o['data']['roleList'].forEach(
            (r) => {
              const rol = new Rol();
              Object.assign(rol, r);
              rol.CenterList = new Array<Center>();
              rol.MenuOptions = new Array<MenuSection>();
              r['centerList'].forEach(
                (c) => {
                  const center = new Center();
                  Object.assign(center, c);
                  rol.CenterList.push(center);
              });
              r['menuOptions'].forEach(
                (ms) => {
                  const menuSection = new MenuSection();
                  Object.assign(menuSection, ms);
                  rol.MenuOptions.push(menuSection);
              });
              roles.push(rol);
            }
          );
          return roles;
        })
      );
    }
    return EMPTY;
  }

  public getRoleInfo(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.getRoleInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const rol = new Rol();
          Object.assign(rol, o['data']);
          rol.CenterList = new Array<Center>();
          rol.MenuOptions = new Array<MenuSection>();
          o['data']['centerList'].forEach(
            (c) => {
              const center = new Center();
              Object.assign(center, c);
              rol.CenterList.push(center);
            }
          );
          o['data']['menuOptions'].forEach(
            (ms) => {
              const menuSection = new MenuSection();
              Object.assign(menuSection, ms);
              rol.MenuOptions.push(menuSection);
            }
          );
          return rol;
        })
      );
    }
    return EMPTY;
  }

  public addNewRole(roleFatherInternalId, companyInternalId, rolename, menuOptions) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.addNewRole(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), roleFatherInternalId, companyInternalId, rolename, menuOptions).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateRoleInfo(internalId, companyInternalId, rolename) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.updateRoleInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, companyInternalId, rolename).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateRoleMenuOptions(internalId, companyInternalId, menuOptions) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.updateRoleMenuOptions(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, companyInternalId, menuOptions).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public deleteRole(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.rolesDaoService.deleteRole(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshRoles() {
    this.refreshRolesListener.next();
  }

  public refreshRolesListen() {
    return this.refreshRolesListener.asObservable();
  }

  public refreshRole() {
    this.refreshRoleListener.next();
  }

  public refreshRoleListen() {
    return this.refreshRoleListener.asObservable();
  }

  public searchRoles(filterKey) {
    this.searchRolesListener.next(filterKey);
  }

  public searchRolesListen() {
    return this.searchRolesListener.asObservable();
  }
}
